import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { Check, Circle, Clock } from 'lucide-react';

const columns = [
  { key: 'todo', labelKey: 'tasks.todo', dot: 'bg-rose-400' },
  { key: 'progress', labelKey: 'tasks.inProgress', dot: 'bg-amber-400' },
  { key: 'done', labelKey: 'tasks.completed', dot: 'bg-emerald-400' },
];

const priorityStyle = { high: 'bg-rose-100 text-rose-600', medium: 'bg-amber-100 text-amber-600', low: 'bg-zinc-100 text-zinc-500' };

const Tasks = () => {
  const { t, tx, data } = useApp();
  const [tasks, setTasks] = useState(data.tasks);

  const advance = (id) => setTasks((ts) => ts.map((x) => x.id === id ? { ...x, status: x.status === 'todo' ? 'progress' : 'done' } : x));

  return (
    <div>
      <PageHeader title={t('tasks.title')} subtitle={t('tasks.subtitle')} />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {columns.map((col) => {
          const items = tasks.filter((x) => x.status === col.key);
          return (
            <div key={col.key} data-testid={`task-col-${col.key}`}>
              <div className="flex items-center gap-2 mb-3 px-1">
                <span className={`w-2.5 h-2.5 rounded-full ${col.dot}`} />
                <h3 className="font-heading font-semibold text-sm fp-page-title">{t(col.labelKey)}</h3>
                <span className="text-xs text-zinc-400 font-mono-num">{items.length}</span>
              </div>
              <div className="space-y-2.5">
                {items.map((task, i) => (
                  <motion.div key={task.id} layout initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}>
                    <Card className="p-4" data-testid={`task-${task.id}`}>
                      <div className="flex items-start gap-3">
                        <button
                          onClick={() => task.status !== 'done' && advance(task.id)}
                          disabled={task.status === 'done'}
                          data-testid={`task-toggle-${task.id}`}
                          className={`mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${task.status === 'done' ? 'bg-emerald-500 border-emerald-500' : 'border-zinc-300 hover:border-cyan-500'}`}
                        >
                          {task.status === 'done' && <Check className="w-3 h-3 text-white" />}
                        </button>
                        <div className="flex-1">
                          <p className={`text-sm leading-snug ${task.status === 'done' ? 'text-zinc-400 line-through' : 'text-zinc-800'}`}>{tx(task.title)}</p>
                          <span className={`inline-block mt-2 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded ${priorityStyle[task.priority]}`}>{task.priority}</span>
                        </div>
                      </div>
                    </Card>
                  </motion.div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tasks;
